import React from "react"

export default function Container({ children }) {
  return <div class="container">{children}</div>
} 